module.exports = new __parcel__URL__("Wave2.22db6b94.svg").toString();